import { listingAPI } from '../lib/api';

interface Envelope<T> {
  success: boolean;
  data: T;
}

export interface ActiveThemeResponse {
  activeTheme: string;
}

export interface FeatureFlag {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
  rollout: number;
}

export const platformService = {
  getActiveTheme: () =>
    listingAPI
      .get<Envelope<ActiveThemeResponse>>('/v1/platform/theme')
      .then((r) => r.data.data),

  setActiveTheme: (activeTheme: string) =>
    listingAPI
      .put<Envelope<ActiveThemeResponse>>('/v1/platform/theme', { activeTheme })
      .then((r) => r.data.data),

  listFeatureFlags: () =>
    listingAPI
      .get<Envelope<{ flags: FeatureFlag[] }>>('/v1/platform/feature-flags')
      .then((r) => r.data.data.flags),

  createFeatureFlag: (input: { key: string; name: string; description?: string; enabled?: boolean; rollout?: number }) =>
    listingAPI
      .post<Envelope<{ flag: FeatureFlag }>>('/v1/platform/feature-flags', input)
      .then((r) => r.data.data.flag),

  updateFeatureFlag: (key: string, updates: { enabled?: boolean; rollout?: number }) =>
    listingAPI
      .patch<Envelope<{ flag: FeatureFlag }>>(`/v1/platform/feature-flags/${key}`, updates)
      .then((r) => r.data.data.flag),

  deleteFeatureFlag: (key: string) =>
    listingAPI.delete(`/v1/platform/feature-flags/${key}`).then((r) => r.data),

  getMaintenanceMode: () =>
    listingAPI
      .get<Envelope<{ enabled: boolean }>>('/v1/platform/maintenance-mode')
      .then((r) => r.data.data),

  setMaintenanceMode: (enabled: boolean) =>
    listingAPI
      .put<Envelope<{ enabled: boolean }>>('/v1/platform/maintenance-mode', { enabled })
      .then((r) => r.data.data),
};
